<pr-template-editor-form
  [template]="template$ | ngrxPush"
  [isSystemTemplate]="isSystemTemplate()"
  [isAutomationTemplate]="isAutomationTemplate()"
  [context]="context$ | ngrxPush"
  (templateChange)="templateChange.emit($event)"
/>
